import { render } from "./BannersComponent.vue?vue&type=template&id=e758ac36&ts=true"
import script from "./BannersComponent.vue?vue&type=script&lang=ts"
export * from "./BannersComponent.vue?vue&type=script&lang=ts"

import "./BannersComponent.vue?vue&type=style&index=0&id=e758ac36&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__